var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScribbleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01911 23.3826C1.01911 23.3826 25.2666 9.2086 56.9486 23.3311",
    stroke: "#00C68E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0847 29.647C47.1942 29.4829 58.2765 24.055 58.2765 24.055C58.2765 24.055 55.5664 17.8788 53.2989 13.7658",
    stroke: "#00C68E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleArrowRight);
export default __webpack_public_path__ + "static/media/scribble-arrow-right.0fa8cf710bf26b8ac4e7e88b03f5bcdb.svg";
export { ForwardRef as ReactComponent };